import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { DiagramComponent, DiagramInfo } from "@/types/diagram";
import { useMutation } from "@tanstack/react-query";
import { v4 as uuidv4 } from "uuid";
import { apiFetch } from "@/lib/api-client";

type SaveDiagramRequest = {
  name: string;
  description: string;
  diagramComponents: DiagramComponent[];
  svgContent: string;
  uuid: string;
};

const saveDiagram = async (
  payload: SaveDiagramRequest & { token: string }
): Promise<DiagramInfo | undefined> => {
  const url = `${config.isometricApiUrl}/diagram`;

  // Generate a new UUID if one doesn't exist in the URL

  const body = {
    name: payload.name,
    version: "1.0.0",
    metadata: {
      description: payload.description,
      svgContent: payload.svgContent,
    },
    uuid: payload.uuid || uuidv4(),
    diagramComponents: payload.diagramComponents,
  };
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    return await response.json(); // Parse the JSON response
  } catch (error) {
    console.error("Error:", error); // Handle errors
    throw error;
  }
};
export default function useSaveDiagram(
  onSettled?: (res: any | undefined, error: Error | null) => void
) {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (params: SaveDiagramRequest) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return saveDiagram({ ...params, token });
    },
    onSettled,
  });
}
